var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteqr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6 22.4C22.9373 22.4 22.4 22.9373 22.4 23.6V26C22.4 26.6627 21.8627 27.2 21.2 27.2C20.5373 27.2 20 26.6627 20 26V23.6C20 21.6118 21.6118 20 23.6 20H26C26.6627 20 27.2 20.5373 27.2 21.2C27.2 21.8627 26.6627 22.4 26 22.4H23.6Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8 21.2C36.8 20.5373 37.3373 20 38 20H40.4C42.3883 20 44 21.6118 44 23.6V26C44 26.6627 43.4628 27.2 42.8 27.2C42.1373 27.2 41.6 26.6627 41.6 26V23.6C41.6 22.9373 41.0628 22.4 40.4 22.4H38C37.3373 22.4 36.8 21.8627 36.8 21.2Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2 36.8008C21.8627 36.8008 22.4 37.338 22.4 38.0008V40.4008C22.4 41.0635 22.9373 41.6008 23.6 41.6008H26C26.6627 41.6008 27.2 42.138 27.2 42.8008C27.2 43.4635 26.6627 44.0008 26 44.0008H23.6C21.6118 44.0008 20 42.3891 20 40.4008V38.0008C20 37.338 20.5373 36.8008 21.2 36.8008Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8 36.8008C43.4628 36.8008 44 37.338 44 38.0008V40.4008C44 42.3891 42.3883 44.0008 40.4 44.0008H38C37.3373 44.0008 36.8 43.4635 36.8 42.8008C36.8 42.138 37.3373 41.6008 38 41.6008H40.4C41.0628 41.6008 41.6 41.0635 41.6 40.4008V38.0008C41.6 37.338 42.1373 36.8008 42.8 36.8008Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6001 29.6016C23.6001 30.2643 24.1374 30.8016 24.8001 30.8016H29.6001C30.2629 30.8016 30.8001 30.2643 30.8001 29.6016V24.8016C30.8001 24.1388 30.2629 23.6016 29.6001 23.6016H24.8001C24.1374 23.6016 23.6001 24.1388 23.6001 24.8016V29.6016ZM26.0001 28.4016V26.0016H28.4001V28.4016H26.0001Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8001 40.3992C24.1374 40.3992 23.6001 39.862 23.6001 39.1992V34.3992C23.6001 33.7365 24.1374 33.1992 24.8001 33.1992H29.6001C30.2629 33.1992 30.8001 33.7365 30.8001 34.3992V39.1992C30.8001 39.862 30.2629 40.3992 29.6001 40.3992H24.8001ZM26.0001 35.5992V37.9992H28.4001V35.5992H26.0001Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2 29.6016C33.2 30.2643 33.7372 30.8016 34.4 30.8016H39.2C39.8627 30.8016 40.4 30.2643 40.4 29.6016V24.8016C40.4 24.1388 39.8627 23.6016 39.2 23.6016H34.4C33.7372 23.6016 33.2 24.1388 33.2 24.8016V29.6016ZM35.6 28.4016V26.0016H38V28.4016H35.6Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4 40.3992C33.7372 40.3992 33.2 39.862 33.2 39.1992V34.3992C33.2 33.7365 33.7372 33.1992 34.4 33.1992H39.2C39.8627 33.1992 40.4 33.7365 40.4 34.3992V39.1992C40.4 39.862 39.8627 40.3992 39.2 40.3992H34.4ZM35.6 35.5992V37.9992H38V35.5992H35.6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteqr);
export default __webpack_public_path__ + "static/media/invite qr.3e366beff079447545a7275c94908ec2.svg";
export { ForwardRef as ReactComponent };